import { createSlice } from '@reduxjs/toolkit'

import { logoutUser } from '../actions/userActions'
import { createLoadingReducer } from './shared'
import { AdBreak } from 'common/api/v1/types'
import { clearAdBreak, deleteAdBreak, deleteAdBreaks, getAdBreak, listAdBreaks } from '../actions/adBreakActions'
import type { ApplicationException } from '../../api/ApplicationException'

interface State {
  adBreaks: Array<AdBreak>
  selectedAdBreak?: AdBreak
  total: number
  loading: boolean
  formErrors?: ApplicationException['errorInfo']['details']
}

export const initialAdBreaks: State = {
  adBreaks: [],
  selectedAdBreak: undefined,
  total: 0,
  loading: false,
  formErrors: undefined,
}

const { isLoadingAction, loadingReducer } = createLoadingReducer<State>(listAdBreaks)

const adBreakSlice = createSlice({
  name: 'adBreak',
  initialState: initialAdBreaks,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdBreak.fulfilled, (state, { payload: selectedAdBreak }): State => ({ ...state, selectedAdBreak }))
      .addCase(clearAdBreak, (state): State => ({ ...state, selectedAdBreak: undefined }))

      .addCase(deleteAdBreak.pending, (state): State => ({ ...state }))
      .addCase(deleteAdBreak.rejected, (state): State => ({ ...state }))
      .addCase(
        deleteAdBreak.fulfilled,
        (state, { payload: e }): State => ({
          ...state,
          adBreaks: state.adBreaks.filter((o) => o.id !== e.id),
        }),
      )
      .addCase(
        deleteAdBreaks.fulfilled,
        (state, { payload: ids }): State => ({
          ...state,
          adBreaks: state.adBreaks.filter((o) => !ids.includes(o.id)),
        }),
      )
      .addCase(
        listAdBreaks.fulfilled,
        (state, { payload: adBreaks }): State => ({
          ...state,
          adBreaks: adBreaks.items,
          total: adBreaks.total,
          loading: false,
        }),
      )
      .addCase(logoutUser.fulfilled, (): State => initialAdBreaks)
      .addMatcher(isLoadingAction, loadingReducer)
  },
})

export default adBreakSlice.reducer
